import { render, staticRenderFns } from "./AppealCenter.vue?vue&type=template&id=4478fd7e&scoped=true&"
import script from "./AppealCenter.vue?vue&type=script&lang=js&"
export * from "./AppealCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4478fd7e",
  null
  
)

export default component.exports